import ExportBase from "../exportbase";

import LabelDialog from "../../../../../dialogs/labeldialog";
import DialogInputBox from "../../../../../dialogs/inputbox";
import SelectSequence from "../../../sequences/selectsequence/selectsequence";

import { apiReadOneAsset } from "../../../../../../utils/apis";

import React from "react";

class ExportDOCXTR extends ExportBase 
{


constructor(props)
{
    super(props);

    this.state.formulaire =
    {
        timecode:true,
        speakers: true,
        coverpage: true,
        sequences: false,

    }
        
    
    this.timecodeRef = React.createRef();
    this.speakersRef = React.createRef();
    this.coverpageRef = React.createRef();
        
    this.sequenceid = 0;
    this.sequences= false;
    this.sequencesAsset = {};
    this.sequenceRef = React.createRef();



    this.onAssetDownloaded = this.onAssetDownloaded.bind(this)
    this.handleOnChange = this.handleOnChange.bind(this)

    this.onClickOnSequence = this.onClickOnSequence.bind(this);
    this.readSequenceCallBack = this.readSequenceCallBack.bind(this);
    this.readSequenceCallBackFirstTime = this.readSequenceCallBackFirstTime.bind(this)

    this.ready = false;
    this.lastFormulaireSend = "";

}

componentDidMount()
{
    super.componentDidMount();

    if ((this.props.assetsList) && (this.props.assetsList.length > 0))
    {
        var found = -1;
        this.props.assetsList.forEach((element,index) => {
            if ( (found === -1) &&  (element.astype === 8)) found = index;
        });
        if (found !== -1)
        {
            const datas = {asid: this.props.assetsList[found].asid};
            apiReadOneAsset(datas, this.readSequenceCallBackFirstTime)
        }
    }
    
}

componentDidUpdate()
{
    super.componentDidUpdate()
    
}

onClickOnSequence(item, index)
{
    
    this.sequencesAsset = item;
    this.sequenceDatas = null;
    this.sequenceid = 0;



    this.sendFormulaire();

    // on lit l'asset

    const datas = {asid: item.asid};
    apiReadOneAsset(datas, this.readSequenceCallBack)

}

readSequenceCallBack(datas)
{
    if (datas.ret)
    {
        
        this.sequenceDatas = JSON.parse(datas.asdatas);
        this.sequenceid = datas.asid;
        this.sendFormulaire();
    }
}

readSequenceCallBackFirstTime(datas)
{
    if (datas.ret)
    {
        
        this.sequenceDatas = JSON.parse(datas.asdatas);
        this.sequenceid = datas.asid;
    }
}


createWorker()
{
    
    return new Worker(new URL('./docxtrworker.js', import.meta.url));
}

sendFormulaire()
{
    
    var datas = {};
    
    datas = {
        timecode : this.timecodeRef.current.getValue(),
        speakers : this.speakersRef.current.getValue(),
        coverpage: this.coverpageRef.current.getValue(),
    }

    datas.sequences = this.sequenceRef.current.getValue();
    datas.sequenceid = this.sequenceid;

    if (this.lastFormulaireSend !== JSON.stringify(datas))
    {
        this.lastFormulaireSend = JSON.stringify(datas);
        {
            datas.sequenceDatas = this.sequenceDatas;
            this.startComputeFile(datas)
        }
    }



    
    
}


handleOnChange()
{
    if (this.ready) this.sendFormulaire();
};

onAssetDownloaded(asset)
{
   
    this.ready = true;

}

render()

{
    // <>{this.props.format}<br/>{this.props.type}<br/>{this.props.title}<br/>{this.props.asid}</>

    return super.render(

    <>
        <LabelDialog
        width = "96%"
        title = {this.context.language=="fr"?"Type de fichier":"File type"}
        />

        <DialogInputBox
        value = {this.state.formulaire.timecode}
        disabled={false}
        autoFocus = {false}
        ref = {this.timecodeRef}
        onChange =  {this.handleOnChange}
        title = {this.context.language=="fr"?" Avec time codes des phrases":" With TimeCode"}
        />

        <br/>

        <DialogInputBox
        value = {this.state.formulaire.speakers}
        disabled={false}
        autoFocus = {false}
        ref = {this.speakersRef}
        onChange =  {this.handleOnChange}
        title = {this.context.language=="fr"?" Avec speakers":" With speakers"}
        />


        <br/>

        <DialogInputBox
        value = {this.state.formulaire.coverpage}
        disabled={false}
        autoFocus = {false}
        ref = {this.coverpageRef}
        onChange =  {this.handleOnChange}
        title = {this.context.language=="fr"?" Avec page de garde":" With cover page"}
        />


        <br/>
        <DialogInputBox
        value = {this.state.formulaire.sequences}
        disabled={false}
        autoFocus = {false}
        ref = {this.sequenceRef}
        onChange =  {this.handleOnChange}
        title = {this.context.language=="fr"?" Inclure les séquences : ":"With sequences :"}
        />

        <SelectSequence onClick = {this.onClickOnSequence} list = {this.props.assetsList}/>

        <br/>



    </>
        
    )
}
}

export default ExportDOCXTR;

